export default __webpack_public_path__ + "static/media/My-Img-6.f0a27fe7.jpg";